import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { processSeoVariables } from '@iheartjane/utils';

export const title = (...parts: (string | undefined)[]) => ({
  title: parts.filter(Boolean).join(' | ') || 'Jane Premium',
});

export const getMetaTitle = (
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) => title(processSeoVariables(customSEOPage?.title, metaVariables));
